// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"FullScreenImage_fullscreen__3ckgR","black":"FullScreenImage_black__2Xuzo","imageText":"FullScreenImage_imageText__1YIXQ"};